export const APP_STORE_LINK = 'https://apps.apple.com/ru/app/id1619752843';
export const GOOGLE_PLAY_LINK =
  'https://play.google.com/store/apps/details?id=ru.vk.hrtek';
export const RU_STORE_LINK = 'https://www.rustore.ru/catalog/app/ru.vk.hrtek';
export const APP_GALLERY_LINK =
  'https://appgallery.huawei.com/#/app/C107531675';
